import { Typography } from '@mui/material'

export default function BulkEditPrevalidateError() {
  return (
    <>
      <Typography variant="h2">Can't Perform Bulk Edit</Typography>
      <Typography>
        Due to an error bulk edits can't be made with these items.
      </Typography>
      <Typography>
        Verify that you have permissions for the documents that you are
        attempting to edit.
      </Typography>
    </>
  )
}
